var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.25 2C11.25 1.58579 11.5858 1.25 12 1.25C17.937 1.25 22.75 6.06293 22.75 12C22.75 17.937 17.937 22.75 12 22.75C6.06293 22.75 1.25 17.937 1.25 12C1.25 10.2851 1.6521 8.66202 2.36783 7.22178C2.55217 6.85085 3.00231 6.69959 3.37325 6.88392C3.74418 7.06826 3.89544 7.5184 3.71111 7.88934C3.09614 9.12678 2.75 10.5219 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C11.5858 2.75 11.25 2.41421 11.25 2Z","fill":"currentColor"}));
}

Loader.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Loader;

Loader.default = Loader;
